import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { RootState } from '../redux/store';
import { loadCurve, trackCurve } from '../utils/curve';
import { STEPS } from '../utils/constants';

// Route segment → funnel step name sent to Curve; smart-booking is an entry route outside STEPS.
const CURVE_STEPS: Record<string, string> = Object.fromEntries([
  ...STEPS.map(s => [s.key, s.slug]),
  ['smart-booking', 'smart_booking'],
]);

function stepFromPath(pathname: string): string {
  const match = pathname.match(/\/bookonline\/([^/]+)/);
  if (!match) return 'landing';
  return CURVE_STEPS[match[1]] ?? match[1];
}

// Loads Curve once the practice payload arrives and reports each scheduler step the visitor reaches.
export const useCurveTracking = () => {
  const curveKey = useSelector((s: RootState) => s.auth.practice?.curve_tracking_key);
  const { pathname } = useLocation();

  useEffect(() => {
    if (curveKey) loadCurve(curveKey);
  }, [curveKey]);

  useEffect(() => {
    if (!curveKey) return;
    trackCurve('scheduler_step', { step: stepFromPath(pathname) });
  }, [curveKey, pathname]);
};
